import { useScreenSize } from '@mchs/web-core';
import { useEffect, useState } from 'react';

export function useResponsiveSize(): {
  isNarrowWidth: boolean,
  screenSize: { width: number; height: number }
} {
  const [isNarrowWidth, setIsNarrowWidth] = useState<boolean>(false);

  const screenSize = useScreenSize();

  useEffect(() => {
    setIsNarrowWidth(screenSize.width < 768);
  }, [screenSize.width]);

  return {isNarrowWidth, screenSize};
}
